import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function WhoItsFor() {
  return <Section data-id="element-154">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-155">
        {/* For You */}
        <div className="bg-sage-light/40 p-6 rounded-2xl" data-id="element-156">
          <h3 className="text-xl font-bold mb-6 text-sage-dark" data-id="element-157">
            Es para vos si:
          </h3>
          <ul className="space-y-4" data-id="element-158">
            {['querés comer más ordenada sin vivir midiendo todo', 'querés bajar la ansiedad de "¿qué como?"', 'querés algo que funcione incluso cuando estás cansada'].map((item, idx) => <li key={idx} className="flex gap-3" data-id="element-159">
                <Check className="w-5 h-5 text-sage mt-0.5 flex-shrink-0" data-id="element-160" />
                <span className="text-brown-body" data-id="element-161">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="bg-amber-light p-6 rounded-2xl border border-amber/10" data-id="element-162">
          <h3 className="text-xl font-bold mb-6 text-amber" data-id="element-163">
            No es para vos si:
          </h3>
          <ul className="space-y-4" data-id="element-164">
            {['buscás promesas clínicas o "curas"', 'querés un plan médico personalizado', 'no querés cocinar nada nunca'].map((item, idx) => <li key={idx} className="flex gap-3" data-id="element-165">
                <X className="w-5 h-5 text-amber mt-0.5 flex-shrink-0" data-id="element-166" />
                <span className="text-brown-body" data-id="element-167">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}